import * as React from "react";
const SvgFiRrBowlRice = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bowl-rice_svg__a)">
      <path
        fill="#062147"
        d="M9.007 6.507a1.5 1.5 0 1 1 3.001.001 1.5 1.5 0 0 1-3.001-.001m14.836 8.651c-.706 2.42-1.988 4.604-3.707 6.316-1.618 1.61-3.902 2.534-6.269 2.534h-3.722c-2.366 0-4.65-.924-6.268-2.533-1.718-1.712-3-3.896-3.707-6.317a4 4 0 0 1 .642-3.551 4 4 0 0 1 1.243-1.092 4.4 4.4 0 0 1-.047-.64 4.26 4.26 0 0 1 2.008-3.629 3 3 0 0 1-.009-.238c0-2.351 2.053-4.266 4.437-3.974A4.15 4.15 0 0 1 12.008.006a4.15 4.15 0 0 1 3.564 2.027c2.315-.276 4.345 1.541 4.433 3.819a4.28 4.28 0 0 1 1.885 4.624c.506.271.953.653 1.312 1.13a4 4 0 0 1 .642 3.551zM4.008 9.874q0 .067.004.134h9.076A1.502 1.502 0 0 1 14.5 8a1.5 1.5 0 0 1 1.412 2.008h4.035q.06-.259.061-.531c0-.925-.561-1.757-1.429-2.119a1 1 0 0 1-.604-1.067c.017-.115.032-.197.032-.283 0-1.103-.897-2-2-2-.21 0-.428.041-.664.125a.996.996 0 0 1-1.285-.628 2.165 2.165 0 0 0-2.051-1.498c-.931 0-1.755.603-2.052 1.499a1 1 0 0 1-1.285.627 2 2 0 0 0-.664-.125c-1.103 0-2 .897-2 2 0 .153.026.321.084.529a1 1 0 0 1-.603 1.198 2.29 2.29 0 0 0-1.48 2.14zm17.593 2.933a1.98 1.98 0 0 0-1.597-.799H4.009c-.634 0-1.216.291-1.596.798a2.02 2.02 0 0 0-.322 1.791c.604 2.068 1.739 4.008 3.199 5.46 1.244 1.24 3.015 1.951 4.855 1.951h3.722c1.841 0 3.611-.711 4.857-1.951 1.459-1.454 2.595-3.393 3.198-5.46a2.02 2.02 0 0 0-.321-1.79"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bowl-rice_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBowlRice;
